<template>
  <router-view />
</template>
<script>
  export default {
    name: 'FluxoCaixaMovimentacoesModule',
  }
</script>
